import React, { useEffect, useState } from "react";
import {
  MainContainer,
  ProceedButton,
} from "../Pages/OnBoarding/components/Common/Common";
import styled from "styled-components";
import { FaArrowLeft } from "react-icons/fa"; // Import the back arrow icon from react-icons
import { useNavigate } from "react-router-dom";
import axios from "axios";

// Styled components for the new sections
const Timestamp = styled.p`
  font-size: 14px;
  color: gray;
`;

const Description = styled.footer`
  color: #6e6f76;

  /* Text-14px */
  font-family: sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18.2px;
`;

const Footer = styled.footer`
  padding: 0;
  margin-top: auto;
`;

const HealthDetail = styled.div`
  display: flex;
  flex-direction: column; /* Ensures title and value are in separate rows */
  gap: 4px;
`;

const HealthValue = styled.div`
  color: #2f313b;
  font-family: sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 800;
  line-height: 24px; /* 171.429% */
`;

const HealthTitle = styled.div`
  color: #6e6f76;
  font-family: sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18.2px; /* 130% */
`;
const Box = styled.div`
  border: 1px dashed #000;
  border-radius: 4px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
  padding: 20px;
  height: 100%;
`;

const TopSection = styled.div`
  margin-top: 0;
  display: flex;
  align-items: center;
`;

const MiddleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 0;
`;

const HealthScoreTitle = styled.p`
  color: #2f313b;

  /* Text-16px */
  font-family: sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
`;
const BottomButtons = styled.div`
  font-size: 16px;
  background-color: "#d3d3d3";
  color: "white";
  border: none;
  border-radius: 4px;
  cursor: "pointer";
  transition: background-color 0.3s;
`;
const HealthScoreValue = styled.p`
  color: #05a8aa;

  /* Text-16px */
  font-family: sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
`;
const Text = styled.p`
  font-size: 20px;
  background-color: beige;
  font-weight: bold;
  padding: 20px;
  align-items: center;
  color: red;
  padding-bottom: 65px;
`;

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; // Takes full viewport height
  width: 100vw; // Takes full viewport width
  position: absolute;
  top: 0;
  left: 0;
`;
const SkipButton = styled.button`
  width: 100%;
  padding: 12px;
  font-size: 20px;
  border: 1px solid rgba(47, 49, 59, 0.5);
  background: rgb(0 0 0);
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 20px;
  color: white;
`;

const ProceedButtonYes = styled.button<{ disabled?: boolean }>`
  position: absolute;
  width: 30%;
  margin-top: 0px;
  padding: 9px;
  font-size: 16px;
  background-color: rgb(111, 83, 83);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  left: 8%;
  top: 63%;
`;
const Box2 = styled.div`
  padding: 16px;
  border-radius: 4px;
  border: 1px dashed #000;
  display: flex;
  justify-content: space-between; /* Title on the left, value on the right */
  align-items: center;
`;
const ProceedButtonNo = styled.button<{ disabled?: boolean }>`
  position: absolute;
  width: 30%;
  margin-top: 0px;
  padding: 9px;
  font-size: 16px;
  background-color: rgb(111, 83, 83);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  left: 61%;
  top: 62%;
`;

const ResultPage = ({ vitalSigns, onContinue }) => {
  const navigate = useNavigate();
  const [showResult, setShowResult] = useState(false);

  const userName =
    JSON.parse(localStorage.getItem("userBMI") || "{}").name || null;

  const formatValue = (key, value) => {
    if (value === null || value === undefined) {
      return ""; // Return an empty string when the value is null or undefined
    }

    if (key === "bloodPressure" && value) {
      return `${value.systolic}/${value.diastolic} mmHg`;
    }
    if (key === "hemoglobin" && value) {
      return `${value} g/dL`;
    }
    if (key === "hemoglobinA1c" && value) {
      return `${value}%`;
    }
    if (key === "highBloodPressureRisk" && value != null) {
      return value === 0
        ? "Unknown"
        : value === 1
        ? "Low Risk"
        : value === 2
        ? "Medium Risk"
        : "High Risk";
    }

    if (key === "highFastingGlucoseRisk" && value != null) {
      return value === 0
        ? "Unknown"
        : value === 1
        ? "Low Risk"
        : value === 2
        ? "Medium Risk"
        : "High Risk";
    }
    if (key === "highHemoglobinA1CRisk" && value != null) {
      return value === 0
        ? "Unknown"
        : value === 1
        ? "Low Risk"
        : value === 2
        ? "Medium Risk"
        : "High Risk";
    }
    if (key === "highTotalCholesterolRisk" && value != null) {
      return value === 0
        ? "Unknown"
        : value === 1
        ? "Low Risk"
        : value === 2
        ? "Medium Risk"
        : "High Risk";
    }
    if (key === "lowHemoglobinRisk" && value != null) {
      return value === 0
        ? "Unknown"
        : value === 1
        ? "Low Risk"
        : value === 2
        ? "Medium Risk"
        : "High Risk";
    }
    if (key === "ascvdRisk" && value != null) {
      return value === 0
        ? "Unknown"
        : value === 1
        ? "Low Risk"
        : value === 2
        ? "Medium Risk"
        : "High Risk";
    }
    if (key === "wellnessLevel" && value != null) {
      return value === 0
        ? "Unknown"
        : value === 1
        ? "Low Risk"
        : value === 2
        ? "Medium Risk"
        : "High Risk";
    }
    if (key === "wellnessIndex" && value != null) {
      return value === 0
        ? "Unknown"
        : value === 1
        ? "Low Risk"
        : value === 2
        ? "Medium Risk"
        : "High Risk";
    }

    return `${value} ${key === "pulseRate" ? "bpm" : ""}`;
  };

  const vitalSignsMapping = [
    {
      title: "Respiration Rate",
      key: "respirationRate",
    },
    {
      title: "PRQ",
      key: "prq",
    },
    {
      title: "Pulse Rate",
      key: "pulseRate",
    },
    {
      title: "Stress Level",
      key: "stressLevel",
    },
    {
      title: "Blood Pressure",
      key: "bloodPressure",
    },
    {
      title: "Wellness Level",
      key: "wellnessLevel",
    },
    {
      title: "Wellness Index",
      key: "wellnessIndex",
    },
    {
      title: "High Blood Pressure Risk",
      key: "highBloodPressureRisk",
    },

    { title: "Hemoglobin", key: "hemoglobin" },
    { title: "Hemoglobin A1C", key: "hemoglobinA1c" },
    { title: "High Fasting Glucose Risk", key: "highFastingGlucoseRisk" },
    { title: "High Hemoglobin A1C Risk", key: "highHemoglobinA1CRisk" },
    { title: "High Total Cholesterol Risk", key: "highTotalCholesterolRisk" },
    { title: "Low Hemoglobin Risk", key: "lowHemoglobinRisk" },
    { title: "ASCVD Risk", key: "ascvdRisk" },
    { title: "Heart Age", key: "heartAge" },
    { title: "Normalized Stress Index", key: "normalizedStressIndex" },
  ];

  const onRetake = () => {
    localStorage.removeItem("ScanIsDone");
    window.location.reload();
  };

  const confidenceLevelPulseRate = vitalSigns?.pulseRate?.confidenceLevel;
  // Calculate health score using provided vitalSigns data
  const systolic = vitalSigns?.bloodPressure?.value?.systolic || 0;
  const diastolic = vitalSigns?.bloodPressure?.value?.diastolic || 0;
  const hba1c = vitalSigns?.hemoglobinA1c?.value || 0;

  const calculateHealthScore = (systolic, diastolic, hba1c) => {
    // Hypertension Risk Score
    let hypertensionRisk;
    if (
      (systolic < 120 && diastolic < 80) ||
      (systolic < 130 && diastolic < 85)
    ) {
      hypertensionRisk = 15; // Low
    } else if (systolic < 140 && diastolic < 90) {
      hypertensionRisk = 10; // Medium
    } else {
      hypertensionRisk = 5; // High
    }

    // Diabetes Risk Score
    let diabetesRisk;
    if (hba1c < 5.7) {
      diabetesRisk = 15; // Low
    } else if (hba1c < 6.4) {
      diabetesRisk = 10; // Medium
    } else {
      diabetesRisk = 5; // High
    }

    // Total Risk Score
    const riskScore = hypertensionRisk + diabetesRisk; // Out of 30

    // Blood Pressure Score (out of 35)
    let bpScore;
    if (systolic < 120 && diastolic < 80) {
      bpScore = 35;
    } else if (systolic < 130 && diastolic < 85) {
      bpScore = 31.5;
    } else if (systolic < 140 && diastolic < 90) {
      bpScore = 26.25;
    } else if (systolic < 160 && diastolic < 100) {
      bpScore = 17.5;
    } else if (systolic < 180 && diastolic < 110) {
      bpScore = 8.75;
    } else {
      bpScore = 0;
    }

    // Diabetes Score (out of 35)
    let diabetesScore;
    if (hba1c < 5.7) {
      diabetesScore = 35;
    } else if (hba1c < 6.4) {
      diabetesScore = 28;
    } else {
      diabetesScore = 17.5;
    }

    // Final Health Score
    const finalHealthScore = riskScore + bpScore + diabetesScore;

    return { finalHealthScore, riskScore, bpScore, diabetesScore };
  };

  const healthScore = calculateHealthScore(systolic, diastolic, hba1c);

  useEffect(() => {
    localStorage.setItem(
      "healthScore",
      JSON.stringify(healthScore.finalHealthScore)
    );
  }, [healthScore.finalHealthScore, vitalSigns]);

  useEffect(() => {
    localStorage.setItem("ScanIsDone", "Done");
  }, []);

  const referralCode = localStorage.getItem("userPassword");
  const storeFaceScanData = async () => {
    try {
      const response = await axios.post(
        "https://pivv-be.yhealth.me/api/store-face-scan-data",
        {
          faceScanResult: vitalSigns,
          referralCode: referralCode,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key":
              "zrEjEPASSLwXksLSBrPtIHTBowGWhttrLvH00sZ96VRNPruYlePN8ZlujLCuyCoqQBbf52TLdCxHZCDAs05NbNZ4zGUDBNuOa7G88CYMvz21lHzy6FI7AXabiOPrtQOE",
          },
        }
      );
      console.log("API Response:", response.data);
    } catch (error) {
      console.error(
        "API Call Failed:",
        error.response?.data?.message || error.message
      );
    }
  };

  const onSkip = () => {
    storeFaceScanData();
    onContinue();
  };

  const scanDone = () => {
    setShowResult(true); // Navigate to the scan page
    storeFaceScanData();
    localStorage.setItem("scanDone", "Done");
  };

  return (
    <>
      {confidenceLevelPulseRate < 3 && !showResult && (
        <TextContainer>
          <Text>
            Your previous face scan resulted in low confidence, which might
            affect the accuracy of the results.
            <br />
            Do you wish to retake the Face Scan?
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <ProceedButtonYes onClick={onRetake}>Yes</ProceedButtonYes>
              <ProceedButtonNo onClick={scanDone} style={{ marginTop: "10px" }}>
                Continue
              </ProceedButtonNo>
            </div>
          </Text>
        </TextContainer>
      )}

      {(confidenceLevelPulseRate === 3 || showResult) && (
        <MainContainer style={{ backgroundColor: "#F4F3EF", height: "100%" }}>
          <MainContent>
            {/* Top section with Back Button */}
            <TopSection>
              <Description>
                <p>This screen will not be visible to the user.</p>
              </Description>
            </TopSection>

            {/* Middle section with health details */}
            <MiddleSection>
              <Box>
                <Timestamp>Timestamp: {new Date().toLocaleString()}</Timestamp>
                {vitalSignsMapping.map(({ title, key }) => {
                  const vitalSign = vitalSigns?.[key]; // Safe access using optional chaining

                  const formattedValue = formatValue(key, vitalSign?.value);
                  return (
                    <HealthDetail key={key}>
                      <HealthTitle>{title} </HealthTitle>
                      <HealthValue>{formattedValue || "-"} </HealthValue>
                    </HealthDetail>
                  );
                })}
              </Box>

              {/* Health Score Section */}
              <Box2>
                <HealthScoreTitle>Health Score</HealthScoreTitle>
                <HealthScoreValue>
                  {healthScore.finalHealthScore}/100
                </HealthScoreValue>
              </Box2>
            </MiddleSection>

            {/* Footer with the full-width button */}
            <Footer>
              <BottomButtons>
                <SkipButton onClick={onSkip}>Next</SkipButton>
              </BottomButtons>
            </Footer>
          </MainContent>
        </MainContainer>
      )}
    </>
  );
};

export default ResultPage;
